import { Translate } from '@chipinside/translate'
import { toast } from 'sonner'

export const copyToClipboard = value => {
  navigator.clipboard.writeText(value)
  toast.success(Translate({ messageKey: 'copied_text_successfully' }), { position: 'top-center' })
}
